// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3BMsx","detailsBorder":"styles_detailsBorder__3RdJZ"};